import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationService } from '../../../core/service/navigation.service';
import { Features, ModuleNames } from '../../model/account-definition';
import { UserAccountService } from '../user-account.service';

@Injectable()
export class LettingFeatureGuard {
  constructor(
    private readonly userAccount: UserAccountService,
    private readonly navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userAccount.current.pipe(
      map(account => {
        if (account.hasAccess(ModuleNames.Properties, Features.EditLettingFeatures)) {
          return true;
        }

        this.navigation.navigatePageNotFound();
        return false;
      })
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }
}
